import React from 'react';

import Block from 'common/components/TouchpointEditor/components/TouchpointNodes/Block';
import { StyledDefaultBlockContainer } from './Block.styles';

export default function DefaultBlockContainer(props) {
    return <StyledDefaultBlockContainer {...props} />;
}

DefaultBlockContainer.splash = {
    ...Block.splash,
    defaultProps: {
        ...Block.splash.defaultProps,
    },
};
